import { Box, Link } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { usePayrollResults } from 'modules/payroll_bundle/lib/PayrollResultContext'
import { UPDATE_DATA } from 'modules/payroll_bundle/lib/constants'
import { usePolicyPeriods } from 'modules/payroll_bundle/lib/policyPeriodsContext'
import resultsCollection from 'modules/payroll_bundle/store/collections/results'

import FileItem from './_FileItem'
import ProcessedResultItem from './_ProcessedResultItem'

const ResultsFilesModal = () => {
  const { resultDispatch, uploadedPayrollResults } = usePayrollResults()
  const { currentPeriod } = usePolicyPeriods()
  const periodName = currentPeriod?.attributes.name
  const resultsCollectionDocumentIds = resultsCollection.models.map(
    (res) => res.attributes.document_id
  )
  const pendingResults = uploadedPayrollResults.filter(
    (el) => !resultsCollectionDocumentIds.includes(el.id)
  )

  const onClose = () => {
    resultDispatch({
      type: UPDATE_DATA,
      payload: {
        showResultsFilesModal: false,
      },
    })
  }

  const openImportModal = () => {
    resultDispatch({
      type: UPDATE_DATA,
      payload: {
        showResultsFilesModal: false,
        showUploadModal: true,
      },
    })

    track(trackingEvents.payroll.importResult, {
      period_status: currentPeriod?.attributes.status,
    })
  }

  const onProcessResult = (documentId: string) => {
    resultDispatch({
      type: UPDATE_DATA,
      payload: {
        showResultsFilesModal: false,
        showUploadModal: true,
        selectedPayrollResultId: documentId,
      },
    })
  }

  return (
    <Modal
      title={i18n.t('payroll_bundle.payroll_results.result_files.title')}
      description={i18n.t('payroll_bundle.payroll_results.result_files.description', {
        periodName,
      })}
      illustration="file-upload"
      onClose={onClose}
    >
      <Box gap="s16" flexGrow>
        {pendingResults.length > 0 &&
          pendingResults.map((document) => (
            <FileItem
              key={document?.id}
              document={document!}
              documentStatus={i18n.t('payroll_bundle.payroll_results.result_files.pending')}
              onProcessResult={onProcessResult}
            />
          ))}
        {resultsCollection.filterByPolicyPeriod(currentPeriod?.id).map((result) => (
          <ProcessedResultItem
            key={result.id}
            result={result}
            resultStatus={i18n.t('payroll_bundle.payroll_results.result_files.processed')}
          />
        ))}
      </Box>
      <Box paddingTop="s24">
        <Link.Touchable onClick={openImportModal}>
          {i18n.t('payroll_bundle.payroll_results.result_files.process_new_file_v2')}
        </Link.Touchable>
      </Box>
    </Modal>
  )
}

export default observer(ResultsFilesModal)
